module.exports = __webpack_public_path__ + "img/third-1-opened.87039d9c.webp";